<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      user: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            user: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null

      this.logIn({
        user: this.user,
        password: this.password,
      })
        .then((response) => {

          const { access_token } = response


          if(access_token){
            this.tryingToLogIn = false
            this.isAuthError = false
            this.$router.push(
              this.$route.query.redirectFrom || { name: 'Dashboard' }
            )
          }

          this.tryingToLogIn = false
          this.authError = response.message
            ? response.message
            : 'Usuário ou senha inválidos'
          this.isAuthError = true

        })
    },
  },
}
</script>

<template>
  <Layout>
    <!-- end row -->
    <div class="account-pages d-flex align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-10">
            <div class="card">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-md-6 p-5">
                    <div class="mx-auto mb-3">
                      <a routerLink="/">
                        <img
                          src="@assets/images/logo.png"
                          alt
                          style="margin-left: -10px; height: 200px"
                        />
                        <h3 class="d-inline align-middle ml-1 text-logo"></h3>
                      </a>
                    </div>

                    <h6 class="h5 mb-0 mt-4">Bem vindo!</h6>
                    <p class="text-muted mt-1 mb-4"
                      >Entre com seu login e senha.</p
                    >

                    <b-alert
                      v-model="isAuthError"
                      variant="danger"
                      dismissible
                      >{{ authError }}</b-alert
                    >

                    <b-form
                      class="authentication-form"
                      @submit.prevent="tryToLogIn"
                    >
                      <div class="form-group">
                        <label class="form-control-label">Login</label>
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather
                                type="mail"
                                class="align-middle icon-dual"
                              ></feather>
                            </span>
                          </div>
                          <b-form-input
                            id="input-1"
                            v-model="user"
                            type="text"
                            required
                            placeholder="Digite seu login"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Senha</label>

                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather
                                type="lock"
                                class="align-middle icon-dual"
                              ></feather>
                            </span>
                          </div>
                          <b-form-input
                            id="password"
                            v-model="password"
                            type="password"
                            required
                            placeholder="Digite sua senha"
                          ></b-form-input>
                        </div>
                      </div>
                      <b-form-group id="button-group" class="mt-4 mb-1">
                        <b-button
                          type="submit"
                          variant="primary"
                          class="btn-block"
                        >
                          <span v-if="!tryingToLogIn">Entrar</span>
                          <b-spinner v-else small></b-spinner>
                        </b-button>
                      </b-form-group>
                    </b-form>
                  </div>
                  <div class="col-lg-6 d-none d-md-inline-block">
                    <div class="auth-page-sidebar">
                      <div class="overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
  </Layout>
</template>

<style src="./style.scss" lang="scss"/>
